import { createAction, props } from '@ngrx/store';
import { User } from '../../user/models/user.model';

export const fetchAdminsRequest = createAction(
  "[Admins] Fetch Admins Request",
);

export const fetchAdminsSuccess = createAction(
  "[Admins] Fetch Admins Success",
  props<{ admins: { count: number, data: User[] } }>(),
);

export const fetchAdminsFailure = createAction(
  "[Admins] Fetch Admins Failure",
);

export const createAdminsRequest = createAction(
  "[Admins] Create Admins Request",
  props<{ payload: User }>(),
);

export const createAdminsSuccess = createAction(
  "[Admins] Create Admins Success",
  props<{ admin: User }>(),
);

export const createAdminsFailure = createAction(
  "[Admins] Create Admins Failure",
);

export const deleteAdminsRequest = createAction(
  "[Admins] Delete Admins Request",
  props<{ payload: { ids: number[]} }>(),
);

export const deleteAdminsSuccess = createAction(
  "[Admins] Delete Admins Success",
  props<{ ids: number[] }>(),
);

export const deleteAdminsFailure = createAction(
  "[Admins] Delete Admins Failure",
);

export const adminActionTypes = {
  fetchAdminsRequest,
  fetchAdminsSuccess,
  fetchAdminsFailure,
  createAdminsRequest,
  createAdminsSuccess,
  createAdminsFailure,
  deleteAdminsRequest,
  deleteAdminsSuccess,
  deleteAdminsFailure
};
